export const START_OF_DAY = '12:00 AM';
export const END_OF_DAY_UI = '11:59 PM';
export const END_OF_DAY_SAVE = '11:59:59 PM';
